var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 551,
    viewBox: "0 0 1280 551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        opacity: 0.999;\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #6e67af;\n      }\n\n      .cls-4 {\n        fill: #f9a236;\n      }\n\n      .cls-5 {\n        fill: #b473b0;\n      }\n\n      .cls-6 {\n        fill: #ea5d6a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    className: "cls-1",
    width: 1280,
    height: 551,
    transform: "translate(100.751 490.556)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    className: "cls-2",
    transform: "translate(-100.751 -490.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(100.992 489.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-3",
    d: "M685.223,911.041H295.576C189.91,910.854,92.353,854.933,39.588,764.3a290.551,290.551,0,0,1,.063-292.834L228.876,146.544C281.765,55.86,379.506,0,485.281,0S688.8,55.86,741.687,146.544h0a255.294,255.294,0,0,0-90.054,75.215L641.4,204.023a181.187,181.187,0,0,0-312.229,0L139.622,529.109a176.9,176.9,0,0,0,.017,178.328,180.607,180.607,0,0,0,155.937,89.278H480.962C526.351,865.3,602.46,907.9,685.223,911.041Z",
    transform: "translate(-0.03 0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-4",
    d: "M268.354,526.857a278.852,278.852,0,0,1-21.594,31.669H24.585A180.393,180.393,0,0,0,171.5,464.436a176.891,176.891,0,0,0-2.96-173.2L54.337,95.838l16-27.394A141.711,141.711,0,0,1,137.193,8.905L268.355,233.758A287.265,287.265,0,0,1,268.354,526.857Z",
    transform: "translate(663.007 238.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-5",
    d: "M583.857,666.552C537.819,746.618,451.7,795.842,358.642,795.288H24.5A291.888,291.888,0,0,0,248.435,680.962H358A144.237,144.237,0,0,0,483.211,609.7a141.274,141.274,0,0,0-.285-142.977L322.493,190.4c-36.872-62.969-115.569-88.574-182.987-59.538L81.283,31.107A262.257,262.257,0,0,1,197.569,4.347c93.08-.621,179.226,48.621,225.215,128.736l161.073,276A252.573,252.573,0,0,1,583.857,666.552Z",
    transform: "translate(660.693 116.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-6",
    d: "M445.424,28.738A291.889,291.889,0,0,1,221.489,143.064C138.726,139.921,62.617,97.322,17.228,28.738h428.2Z",
    transform: "translate(464.344 767.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-6",
    d: "M265.752,582.637H59.732c-3.039-4.592-6.078-9.342-8.957-14.093a253.355,253.355,0,0,1,0-257.472L211.848,35.391A277.412,277.412,0,0,1,230.4,8l65.741,112.268-145.078,248.6A141.263,141.263,0,0,0,148.4,507.3a144.054,144.054,0,0,0,117.347,75.335Z",
    transform: "translate(421.2 213.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-6",
    d: "M171.9,104.912a141.711,141.711,0,0,0-66.861,59.538l-16,27.394L23.3,79.735A255.345,255.345,0,0,1,113.674,5.312Z",
    transform: "translate(628.302 142.026)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArt);
export default __webpack_public_path__ + "static/media/back_art.abfc02e84916dc460dd6e34bcc006426.svg";
export { ForwardRef as ReactComponent };